<template>
  <div>
    <modal :title="$t('device.import_calibration_info')" :visible.sync="isShowDialog" width="500px">
      <el-form ref="form" class="uk-flex">
        <el-input style="width: 300px;" readonly
          v-model="file.name"
        />
        <el-upload
          :on-change="handleChange"
          action="x"
          :auto-upload="false"
          :file-list="fileList"
          style="display: inline-block;"
          accept=".xlsx"
          :show-file-list="false"
        >
          <el-button size="small" type="primary" style="padding: 7px 15px;">{{ $t('public.btn_new') }}</el-button>
        </el-upload>
      </el-form>
      <a class="load_btn" @click="downloadTemplate">{{ $t('device.download_calibration') }}</a>
      <div slot="footer">
        <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
        <el-button type="primary" @click="handleUpload">{{ $t('public.btn_confirm') }}</el-button>
      </div>
    </modal>

  </div>
</template>

<script>
import { downloadCalibrationTemplate, saveCalibrationExport } from '@/api/modules/sensor.js'

export default {
  name: 'CalibrationImport',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    choozeTableData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fileList: [],
      file: {}
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    }
  },
  methods: {
    // 下载模板
    downloadTemplate(){
      this.$loading.show({
        text: '下载中...'
      })
      downloadCalibrationTemplate().then(res => {

      }).finally(() => {
        this.$loading.hide()
      })

    },
    handleChange(file, fileList){
      console.log('file, fileList=', file, fileList)
      this.file = file
    },
    handleUpload(){
      console.log('this.file=', this.file)
      if(!this.file.name){
        return this.$message.warning(this.$t('integration.please_select_a_file'))
      }
      var formData = new FormData()
      formData.append('language', 'zh_CN')
      formData.append('uploadFile', this.file.raw)
      saveCalibrationExport(formData).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
          this.isShowDialog = false
          this.file = {}
        }

      })
    }
  }
}
</script>

<style lang="scss" scoped>
.load_btn {
  margin-top: 10px;
  color: var(--primary-color);
  display: inline-block;
}

</style>
